const _getEdap = () => window.edap || [];

const triggerEdapEvent = (eventName, eventData) => {
    window.edap = _getEdap();
    window.edap.push((edap) => {
        edap.trigger(eventName, eventData);
    });
};

export function emitFocusEvent(focusData) {
    let eventName = 'typeahead.focus';
    triggerEdapEvent(eventName, focusData);
}

export function emitStartEvent(prefilledValue) {
    triggerEdapEvent('typeahead.start', {
        prevsearch: prefilledValue
    });
}

export function emitDestinationClearedEvent() {
    triggerEdapEvent('interaction.selected', {
        action_location: 'search-widget',
        event_action: 'destination_cleared'
    });
}

/**
 * emitGE()
 * options {mixed} - edap parameters for events
 */
export function emitGE({eventaction, eventlabel = '', eventvalue = ''}) {
    triggerEdapEvent('generic.event', {
        eventcategory: 'typeahead',
        eventaction,
        eventlabel,
        eventvalue
    });
}

/**
 * emitSelectionEvent()
 * Emits selection event for typeahead
 **/
export function emitSelectionEvent(selectionData) {
    let eventName = 'typeahead.selection';
    triggerEdapEvent(eventName, selectionData);
}

/**
 * emitBlurEvent()
 * Emits blur event for typeahead
 **/
export function emitBlurEvent(blurData) {
    let eventName = 'typeahead_blur.presented';
    triggerEdapEvent(eventName, blurData);
}
